module.exports = __webpack_public_path__ + "static/media/RealTimeNotification.65ea3eab.svg";